import CompanyNode from "./components/CompanyNode";

import { customPalette } from "@theme";

const GRAPH_DIRECTION = "TB";
const NODE_SPACING_X = 150;
const NODE_SPACING_Y = 50;
const PRO_OPTIONS = {
  hideAttribution: true,
  account: "paid-pro",
};

const DIAGRAM_COLOR = customPalette.purple[400];

const DEFAULT_EDGE_OPTIONS = {
  markerEnd: "arrow",
  selected: false,
  style: { stroke: DIAGRAM_COLOR, strokeWidth: 2 },
};

const NODE_TYPES = {
  companyNode: CompanyNode,
};

const DEFAULT_POSITION = { x: -1000, y: -1000 };

const EDGE_TYPE = "simplebezier";

export {
  DEFAULT_POSITION,
  EDGE_TYPE,
  GRAPH_DIRECTION,
  NODE_SPACING_X,
  NODE_SPACING_Y,
  PRO_OPTIONS,
  DIAGRAM_COLOR,
  DEFAULT_EDGE_OPTIONS,
  NODE_TYPES,
};
